import "./input.css";
import "./main.css";
import "./index.css";
import "antd/dist/reset.css";
// import "./assets/styles/main.css";
// import "./assets/styles/responsive.css";
// import "./assets/styles/style.css";
import Router from "./route/router"; 

function App() {
  return (
    <div className="App">
      <Router />  
    </div>
  );
}

export default App;
